import { BenchmarkEmptyStateType, resolveBenchmarkEmptyStateType } from 'components/benchmarkEmptyStateUtils';
import { DataEntry } from 'models/data';
import { Measure } from 'services/model/model.service';

export function getBenchmarkEmptyStateType(
  dataSet: DataEntry[],
  improvementMeasure: Measure,
  benchmark: string
): BenchmarkEmptyStateType | null {
  const hasTenantData = dataSet.some(entry => improvementMeasure.code in entry.values);
  const hasTenantHistory = dataSet.some(
    entry => improvementMeasure.code in entry.compareValues && improvementMeasure.getValue(entry.compareValues) > 0
  );
  const hasPeerData = dataSet.some(entry => improvementMeasure.code in (entry.benchmarks?.[benchmark]?.values ?? {}));

  return resolveBenchmarkEmptyStateType({ hasTenantData, hasTenantHistory, hasPeerData });
}
// prefer tenantHistoryEmptyStateType over peerEmptyStateType if both are present
export function getCombinedBenchmarkEmptyStateType(
  dataSet: DataEntry[],
  measures: [Measure, Measure],
  benchmark: string
): BenchmarkEmptyStateType | null {
  const emptyStates = measures.map(measure => getBenchmarkEmptyStateType(dataSet, measure, benchmark));

  return emptyStates[0] && emptyStates[0] === emptyStates[1] ? emptyStates[0] : null;
}
